import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlag = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 14,
	viewBox: "0 0 12 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.35025 1.03356C5.19806 0.3203 3.79348 0.140855 2.49898 0.541535L1.93645 0.715651C1.83001 0.488982 1.59967 0.332034 1.33268 0.332034C0.964493 0.332034 0.666016 0.63051 0.666016 0.9987V12.9987C0.666016 13.3669 0.964492 13.6654 1.33268 13.6654C1.70087 13.6654 1.99935 13.3669 1.99935 12.9987V8.83007C2.11557 8.79876 2.22238 8.76022 2.30445 8.72889C2.37879 8.70052 2.45176 8.66794 2.52684 8.64157C3.53602 8.30081 4.64317 8.40809 5.56799 8.93656C6.78477 9.63187 8.23545 9.79134 9.57422 9.37695L10.4471 9.10677C10.9737 8.94379 11.3327 8.45686 11.3327 7.90566V1.98881C11.3327 1.81074 11.29 1.60392 11.1532 1.41954C11.0152 1.23364 10.8312 1.13727 10.6709 1.09168C10.3889 1.01143 10.0991 1.06435 9.92634 1.10498C9.72758 1.15173 9.53182 1.22188 9.38507 1.27772C9.29199 1.31314 9.20001 1.35371 9.10556 1.38552C8.17946 1.67217 7.17453 1.54383 6.35025 1.03356Z",
		fill: "white"
	})
});
const ForwardRef = forwardRef(SvgFlag);
export default ForwardRef;
